import * as React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { isExternalUserHandlingEnabled } from 'app/infrastructure/hosting';
import { ids } from '../../constants';
import { TextConfigurationTranslation } from '../../../constants';

import styles from './text-list-toolbar.scss';

interface ToolbarProps {
  totalResultHits: number;
  exportExcelFetching: boolean;
  importExcelFetching: boolean;
  onExportToExcel: () => void;
  openExcelImport: () => void;
  translation: TextConfigurationTranslation;
}

export const TextListToolbar: React.FC<ToolbarProps> = props => {
  const { totalResultHits, onExportToExcel, exportExcelFetching, translation, openExcelImport, importExcelFetching } = props;
  const isExportDisabled = !!exportExcelFetching || totalResultHits === 0 || totalResultHits === undefined;

  return <>
    {!isExternalUserHandlingEnabled() && <Link
      id="text-configuration-add-new-button"
      to={routeConstants.textConfigurationAdd}
      className="btn btn-primary">
      {translation.add_custom_text}
    </Link>}
    <div className={styles.meatball}>
      <MeatballMenu closeAfterClick={true}>
        <li className={`${isExportDisabled ? styles.notAllowed : ''}`}>
          <button className="dropdown-item"
            id={ids.export_to_excel}
            onClick={onExportToExcel}
            disabled={isExportDisabled}>
            {translation.excel_export_item_text}
          </button>
        </li>
        <li className={`${importExcelFetching ? styles.notAllowed : ''}`}>
          <button className="dropdown-item"
            id={ids.import_from_excel}
            onClick={openExcelImport}
            disabled={importExcelFetching}>
            {translation.import_from_excel}
          </button>
        </li>
      </MeatballMenu>
    </div>
  </>;
};
